import useChatBot from './useChatBot.js';
import useChatBotAgent from './useChatBotAgent.js';
import { useFeatureContext } from 'contexts/FeatureContext.jsx';

/**
 * A hook that provides the AI ChatBot implementation.
 *
 * @returns {{
 *  isOpen: boolean,
 *  isInitialized: boolean,
 *  open: () => void,
 *  close: () => void
 * }} The chatbot implementation.
 */
export const useAiAssistant = () => {
  const { features } = useFeatureContext();
  // Below condition will be removed when retiring the useChatBot.js
  if (features.aiChatBotAgentEnabled) {
    return useChatBotAgent();
  }
  return useChatBot();
};
